import type { Locale } from "@/lib/i18n";
import { pl, type WLanguageVersionsTranslations } from "./pl";
import { en } from "./en";
import { de } from "./de";

export const wLanguageVersionsTranslations: Record<Locale, WLanguageVersionsTranslations> = {
  pl,
  en,
  de,
};

export type { WLanguageVersionsTranslations };
